var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
var cls = classNames('tab');
export var TabDefaultProps = {
  lineVariant: 'solid',
  lineWidth: 1,
  color: 'text',
  hoverColor: 'dark',
  activeColor: 'dark',
  lineColor: 'line-semi-subtle',
  activeWeight: 500,
  onClick: function onClick() {}
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    cursor: pointer;\n    white-space: nowrap;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: center;\n    font-family: ", ";\n    font-size: ", "; \n    box-sizing: border-box;\n    padding: ", " ", ";\n    font-weight: 400; \n    box-sizing: border-box;\n    padding: ", " ", ";\n\n    ", "\n\n    ", "\n  "], ["\n    ", ";\n    display: flex;\n    cursor: pointer;\n    white-space: nowrap;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: center;\n    font-family: ", ";\n    font-size: ", "; \n    box-sizing: border-box;\n    padding: ", " ", ";\n    font-weight: 400; \n    box-sizing: border-box;\n    padding: ", " ", ";\n\n    ", "\n\n    ", "\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.FONT('sans'), theme.FONT_SIZE(16), theme.UNIT(6), theme.UNIT(6), theme.UNIT(4), theme.UNIT(6), function (_a) {
    var lineWidth = _a.lineWidth,
        lineVariant = _a.lineVariant,
        color = _a.color,
        lineColor = _a.lineColor,
        hoverColor = _a.hoverColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      border-top: ", "px ", " transparent;\n      border-right: ", "px ", " ", ";\n      border-bottom: ", "px ", " ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n      border-top: ", "px ", " transparent;\n      border-right: ", "px ", " ", ";\n      border-bottom: ", "px ", " ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), theme.COLOR(color), lineWidth, lineVariant, lineWidth, lineVariant, theme.COLOR(lineColor), lineWidth, lineVariant, theme.COLOR(lineColor), theme.COLOR(hoverColor));
  }, function (_a) {
    var isActive = _a.isActive,
        lineColor = _a.lineColor,
        activeColor = _a.activeColor,
        activeWeight = _a.activeWeight,
        lineVariant = _a.lineVariant,
        lineWidth = _a.lineWidth;
    return isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-weight: ", "; \n      cursor: default;\n      border-bottom-color: transparent;\n      border-top: ", "px ", " ", ";\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "], ["\n      font-weight: ", "; \n      cursor: default;\n      border-bottom-color: transparent;\n      border-top: ", "px ", " ", ";\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    "])), activeWeight, lineWidth, lineVariant, theme.COLOR(lineColor), theme.COLOR(activeColor), theme.COLOR(activeColor));
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var Tab = function Tab(props) {
  var className = props.className,
      children = props.children,
      rest = __rest(props, ["className", "children"]);

  var aria = rest.isActive ? {
    "aria-selected": "true"
  } : {};
  return (// @ts-ignore
    React.createElement(My.Container, __assign({}, rest, {
      role: "tab"
    }, aria, {
      className: cls.name(className)
    }), children)
  );
};
Tab.cls = cls;
Tab.defaultProps = TabDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;